import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  overflow-x: auto;
  grid-column-gap: 12px;

  align-items: center;
  justify-content: start;

  margin-bottom: 8px;
`;
